import * as React from "react";

import { Head } from "../Head";
import { containerMaxW } from "@/utils/config";
import { Image } from "../Elements";
import { useNavigate } from "react-router-dom";
import { RouteConstant } from "@/routes/routeConstant";

type ContentLayoutProps = {
  children: React.ReactNode;
  title?: string;
  showBackBtn?: boolean;
  header?: React.ReactNode;
};

export const ContentLayout = ({
  children,
  header,
  title,
  showBackBtn,
}: ContentLayoutProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(RouteConstant.Landing);
  };
  return (
    <>
      <Head title={title} />
      <section className={`p-6 ${containerMaxW}`}>
        <section
          className={`mb-6 flex items-center justify-between bg-[#ffffff] p-[2px]`}
        >
          <div className="flex items-center">
            {showBackBtn && (
              <div onClick={handleBack} className="w-[30px] h-[20px] mr-[5px]">
                <Image src="back-grey.png" className="w-full h-full" />
              </div>
            )}
            {title && <h1 className="leading-tight text-3xl">{title}</h1>}
          </div>
          {header}
        </section>
        <section className="p-[10px] max-h-[calc(100vh-170px)] overflow-y-auto">
          {children}
        </section>
      </section>
    </>
  );
};
